import { ReactNode } from 'react';
import { InputText } from 'ui/inputs';
import { Radio } from 'ui/radio';
import { ActionInputText } from '../../types';
import { Container, ErrorText, HelpText, InputTextWrapper, RadioWrapper } from './styles';

type Props = {
  id: string;
  errorText?: ReactNode;
  hasError?: boolean;
  inputText?: ActionInputText;
  label: ReactNode;
  onClick: () => void;
  optionId: string;
  selectedOption: string;
  value: unknown;
};

export const RadioWithInputText = ({
  id,
  errorText,
  hasError,
  inputText,
  label,
  onClick,
  optionId,
  selectedOption,
  value,
}: Props) => {
  return (
    <Container>
      <RadioWrapper>
        <Radio
          data-test={`radio-option-${optionId}`}
          id={`radio-option-${optionId}`}
          isChecked={optionId === selectedOption}
          onClick={onClick}
          value={value}
        />
        {label}
      </RadioWrapper>
      {inputText?.isDisplayed && (
        <InputTextWrapper>
          <InputText
            data-test={`${id}-input`}
            hasError={hasError}
            onChange={inputText.onChange}
            placeholder={inputText.placeholder}
            value={inputText.value}
          />
          {hasError ? (
            <ErrorText data-test="radio-text-input-field-error-text">{errorText}</ErrorText>
          ) : (
            <HelpText>{inputText.helpText}</HelpText>
          )}
        </InputTextWrapper>
      )}
    </Container>
  );
};
